import { classes } from 'html-classes';

interface Props {
  label: string;
  value?: boolean;
  onChange: (values: boolean) => void;
  className?: string;
}

const ProductToggleFilter = ({
  label,
  onChange,
  value = false,
  className,
}: Props) => {
  return (
    <label
      className={classes(['control__switch', 'checkbox-wrapper', className])}
    >
      <input
        onChange={() => onChange(!value)}
        checked={value}
        type="checkbox"
        className="control__switch-input"
        name="express"
      />
      <span className="control__switch-mark" />
      <div className="control__switch-text text-wrapper">
        <div className="description">{label}</div>
      </div>
    </label>
  );
};

export default ProductToggleFilter;
